/** Parses a NavigationRegion2D: Node2D plus the navigation_polygon reference. */
import { parseNode2D } from '../../base/node2d/parser';
export function parseNavigationRegion2D(heading, properties) {
    const baseProperties = parseNode2D(heading, properties);
    return {
        ...baseProperties,
        navigationPolygon: properties.navigation_polygon,
    };
}
//# sourceMappingURL=parser.js.map